<template>
  <div class="salesStatistics">
    <div class="left_salesStatistics">
      <timeChuli
        class="timeChuli"
        @btnClick="xiaoliang"
        @changeTime="changeTime"
        :showChoose="true"
      ></timeChuli>

      <div class="cross">
        <div class="line"></div>
        <div class="info">销售额概览</div>
      </div>

      <div class="cellMoney">
        <img src="../../assets/img/home/money.png" class="img" alt />
        <div class="moenyInfo">
          <div class="money">{{entTotal}}</div>
          <div class="info">公司累计销售额(元)：</div>
        </div>
      </div>

      <dataTable
        ref="dataTable"
        :flush="fresh"
        :inSerachFilte="inSerachFilte"
        :inTableData="tableDataConfig"
        :ispagination="false"
      ></dataTable>
    </div>

    <div class="right_salesStatistics">
      <timeChuli class="timeChuli marleft" :btnList="btnList" @btnClick="btnClick"></timeChuli>

      <div class="ljBox">
      <div class="top_echarts">
        <div class="cross absolute">
          <div class="line"></div>
          <div class="info">销售额曲线</div>
        </div>

        <echarts :option="lineEcharts"></echarts>
      </div>

      </div>

      <div class="bottom_echarts">
        <div class="cross absolute">
          <div class="line"></div>
          <div class="info">商品销量</div>
          <div class="fuwenben">（统计销量前十的商品）</div>
        </div>
        <echarts :option="options"></echarts>
      </div>
    </div>
  </div>
</template>

<script>
import timeChuli from "../components/timeChuli";
import dataTable from "../../components/commonComponents/dataTable";
import echarts from "../../components/commonComponents/echarts";
import moment from "moment";
import dayjs from "dayjs";
import GlobalUtil from "../../utils/globalUtil";

export default {
  components: {
    timeChuli,
    dataTable,
    echarts
  },
  data() {
    return {
      entTotal: 0,
      //用于tableData组件刷新，tableData检测到fresh值发生变化就会刷新数据
      fresh: "",
      // 用于匹配搜索数据，返回新的数据
      inSerachFilte: {},
      //tableData组件参数配置
      tableDataConfig: {
        //表头及字段配置
        tHead: [
          {
            name: "组织",
            field: "orgName"
          },
          {
            name: "销售额（元）",
            field: "orderAmount"
          }
        ],
        //自动渲染
        tData: [],
        //自动渲染
        total: 0,
        actionBtWidth: "250",
        //配置是否显示多选框
        isMultiple: false,
        dispatchp: false,
        //配置是否显示排序
        isRank: true
      },
      btnList: [
        {
          type: "2",
          name: "近一周",
          active: true
        },
        {
          type: "3",
          name: "近一月",
          active: false
        },
        {
          type: "4",
          name: "近一年",
          active: false
        },
        {
          type: "5",
          name: "累计",
          active: false
        }
      ],
      lineEcharts: {},
      options: {},
      timeFlag: "", //
      hourse: moment()
        .startOf("day")
        .format("x"),
      day: dayjs()
        .subtract(7, "day")
        .startOf("day")
        .valueOf(),
      month: dayjs()
        .subtract(1, "month")
        .startOf("month")
        .valueOf(),
      year: dayjs()
        .subtract(1, "year")
        .startOf("month")
        .valueOf(),
      now: moment()
        .endOf("day")
        .format("x"),
      queryParmas: {
        entCode: GlobalUtil.readCookie("entCodeEq"),
        startDate: dayjs()
          .subtract(7, "day")
          .startOf("day")
          .valueOf(),
        endDate: moment()
          .endOf("day")
          .format("x"),
        timeGranularity: "DAY"
      },
      params: {
        pageNumber: 1,
        pageSize: 10,
        queryObj: {
          startDate: dayjs()
            .subtract(7, "day")
            .startOf("day")
            .valueOf(),
          endDate: moment()
            .endOf("day")
            .format("x"),
          entCode: GlobalUtil.readCookie("entCodeEq")
        }
      },
      date: "", //当前时间
      paramsLabel: {
        startDate: moment(new Date())
          .subtract("days")
          .format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        timeFlag: "1"
      }
    };
  },
  methods: {
    xiaoliang(str) {
      console.log(str);
      switch (str) {
        case "1":
          // this.paramsLabel.startDate = moment(new Date()).subtract(1, "days").format("YYYY-MM-DD");
          this.paramsLabel.startDate = moment(new Date()).format("YYYY-MM-DD");
          this.paramsLabel["timeFlag"] = str;
          break;
        case "2":
          this.paramsLabel.startDate = moment(new Date())
            .subtract(7, "days")
            .format("YYYY-MM-DD");
          this.paramsLabel.timeGranularity = "DAY";
          break;
        case "3":
          this.paramsLabel.startDate = moment(new Date())
            .subtract(30, "days")
            .format("YYYY-MM-DD");
          this.paramsLabel.timeGranularity = "DAY";
          break;
        case "4":
          this.paramsLabel.startDate = moment(new Date())
            .subtract(12, "month")
            .format("YYYY-MM-DD");
          this.paramsLabel.timeGranularity = "MONTH";
          break;
        case "5":
          this.paramsLabel.startDate = moment(this.date).format("YYYY-MM-DD");
          this.paramsLabel.timeGranularity = "MONTH";
          break;
      }
      this.timeFlag = str;
      this.paramsLabel.timeFlag = str;
      this.getOrgSalesAmount();
    },
    changeTime(e) {
      if (e) {
        this.paramsLabel.timeFlag = 1;
        this.paramsLabel.startDate = moment(new Date(e[0])).format(
          "YYYY-MM-DD"
        );
        this.paramsLabel.endDate = moment(new Date(e[1])).format("YYYY-MM-DD");
        this.getOrgSalesAmount();
      }
    },
    btnClick(str) {
      switch (str) {
        case "1":
          this.queryParmas.timeGranularity = "HOUR";
          this.queryParmas.startDate = this.hourse;
          this.params.queryObj.startDate = this.hourse;

          break;
        case "2":
          this.queryParmas.timeGranularity = "DAY";
          this.queryParmas.startDate = this.day;
          this.params.queryObj.startDate = this.day;
          break;
        case "3":
          this.queryParmas.timeGranularity = "DAY";
          this.queryParmas.startDate = this.month;
          break;
        case "4":
          this.queryParmas.timeGranularity = "MONTH";
          this.queryParmas.startDate = this.year;
          this.params.queryObj.startDate = this.month;
          break;
        case "5":
          this.queryParmas.timeGranularity = "MONTH";
          this.queryParmas.startDate = this.date;
          this.params.queryObj.startDate = this.year;
          break;
      }
      this.queryParmas.endDate = this.now;
      this.params.queryObj.endDate = this.now;
      this.timeFlag = str;
      this.getEntSalesCurve();
    },

    // 销售曲线
    getEntSalesCurve() {
      this.$axios
        .post(this.$url.admingetEntSalesCurve, this.queryParmas)
        .then(res => {
          console.log("销售曲线", res);
          let data = JSON.parse(JSON.stringify(res.data));
          let xAxisData = data.map(_ => {
            return _.bizDate;
          });
          let seriesData = data.map(_ => {
            return _.amount;
          });
          this.lineEcharts = {
            tooltip: {
              trigger: "axis"
            },
            grid: {
              left: "0%",
              right: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              data: xAxisData
            },
            yAxis: {
              type: "value"
            },
            series: [
              {
                name: "销售额",
                type: "line",
                stack: "总量",
                smooth: true,
                data: seriesData
              }
            ]
          };
        });

      this.$axios.post(this.$url.getitemPayRank, this.params).then(res => {
        if (res) {
          console.error(res);
          let commodity = res.data.list;
          let commodityxAxisData = commodity.map(_ => {
            return _.count;
          });
          let commodityseriesData = commodity.map(_ => {
            return _.name;
          });
          this.options = {
            color: ["#3398DB"],
            grid: {
              left: "0%",
              right: "4%",
              bottom: "3%",
              containLabel: true
            },
            tooltip: {
              trigger: "axis",
              formatter: function(params) {
                console.log(params);
                return params[0].name + ":" + params[0].data;
              }
            },
            xAxis: [
              {
                type: "category",
                data: commodityseriesData,
                axisTick: {
                  alignWithLabel: true
                },
                axisLabel: {
                  interval: 0,
                  formatter: function(value) {
                    if (value && value.length >= 5) {
                      return value.substring(0, 5) + "...";
                    } else {
                      return value;
                    }
                  }
                }
              }
            ],
            yAxis: [
              {
                type: "value",
                minInterval: 1
              }
            ],
            series: [
              {
                type: "bar",
                barWidth: "60%",
                data: commodityxAxisData
              }
            ]
          };
        }
      });
    },
    // 组织销售额
    getOrgSalesAmount() {
      this.$axios
        .get(this.$url.getOrgSalesAmount, this.paramsLabel)
        .then(res => {
          if (res.data) {
            console.log("我是组织销售额", res);
            this.tableDataConfig.tData = res.data.orgAmountList;
            this.entTotal = res.data.entAmount;
          } else {
            this.tableDataConfig.tData = [];
            this.entTotal = 0;
          }
        });
    },
    // 获取企业启用时的日期
    getCreateDate() {
      this.$axios
        .get(this.$url.getEntCreateDate, {
          entCode: GlobalUtil.readCookie("entCodeEq")
        })
        .then(res => {
          if (res) {
            this.date = res.data;
          }
        });
    }
  },

  created() {
    // 销售曲线
    this.getEntSalesCurve(),
      // 组织销售额
      this.getOrgSalesAmount();
    // 企业启用时的日期
    this.getCreateDate();
  }
};
</script>

<style lang='less' scoped>
.salesStatistics {
  height: 1024px;
  width: 100%;
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
  background-color: #fff;
}

.left_salesStatistics {
  height: 100%;
  width: 50%;
  box-sizing: border-box;
  padding: 20px;
  border-right: 2px solid #f0f2f5;
}

.right_salesStatistics {
  height: 100%;
  width: 50%;
  padding: 20px 0;
}

.top_echarts {
  position: relative;
  width: 80%;
  height: 447px;
  padding: 0 20px;
  // border-bottom: 2px solid #f0f2f5;
}
.bottom_echarts {
  position: relative;
  width: 80%;
  height: 447px;
  padding: 0 20px;
}

.timeChuli {
  margin-bottom: 20px;
}
.marleft{
  margin-left: 20px;
}

.cellMoney {
  display: flex;
  margin-left: 5px;
  height: 50px;
  margin-bottom: 25px;
  align-items: center;

  .img {
    height: 48px;
    width: 48px;
    margin-right: 10px;
  }

  .money {
    font-size: 20px;
    font-weight: bold;
    color: rgba(251, 120, 120, 1);
    margin-bottom: 5px;
  }

  .info {
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
}
.ljBox {
  border-bottom: 2px solid #f0f2f5
}

.cross {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  margin-bottom: 30px;

  .line {
    width: 3px;
    height: 19px;
    background: rgba(102, 102, 102, 1);
    margin-right: 5px;
  }

  .info {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }

  .fuwenben {
    font-size: 14px;
    font-weight: 400;
    color: rgba(245, 108, 108, 1);
  }
}

.absolute {
  position: absolute;
  left: 20px;
  top: 15px;
  z-index: 11111;
}
</style>
